import { GameContext } from "../../gameContext";
import {
    expectCurrentScene,
    expectEl,
    expectEls,
    expectGameContext,
} from "../../util";

export function updateNavBtns() {
    const ctx = expectGameContext();

    updateNavBtnsForState(ctx, "video");
    updateNavBtnsForState(ctx, "input");
    updateNavBtnsTogglePlayBtn(ctx);
    updateNavBtnsReplayBtn(ctx);
    updateNavBtnsSceneHistoryPopBtn(ctx);
}

function updateNavBtnsForState(ctx: GameContext, state: "video" | "input") {
    const navEls = expectEls(`#game .navBtns.navBtns--state-${state}`);
    for (const navEl of navEls) {
        if (ctx.gameState.state === state) {
            navEl.classList.remove("--hidden");
        } else {
            navEl.classList.add("--hidden");
        }
    }
}

function updateNavBtnsTogglePlayBtn(ctx: GameContext) {
    const togglePlayBtnDisplay = ctx.gameState.isPlaying ? "Pause" : "Play";
    const togglePlayBtnEls = expectEls<HTMLButtonElement>(
        "#game .navBtns .togglePlayBtn",
    );
    togglePlayBtnEls.forEach((btnEl) => {
        btnEl.innerText = togglePlayBtnDisplay;
    });
}

function updateNavBtnsReplayBtn(_ctx: GameContext) {
    const replayBtnEls = expectEls<HTMLButtonElement>(
        "#game .navBtns .replayBtn",
    );
    const scene = expectCurrentScene();
    const classListFn = scene.video ? "remove" : "add";
    replayBtnEls.forEach((btnEl) => btnEl.classList[classListFn]("--hidden"));
}

function updateNavBtnsSceneHistoryPopBtn(ctx: GameContext) {
    const sceneHistoryPopBtnEls = expectEls<HTMLButtonElement>(
        "#game .navBtns .sceneHistoryPopBtn",
    );
    const classListFn =
        ctx.gameState.sceneHistory.length > 1 ? "remove" : "add";
    sceneHistoryPopBtnEls.forEach((btnEl) =>
        btnEl.classList[classListFn]("--hidden"),
    );
}
